import { useCallback } from "react";
import { Control } from "react-hook-form";
import { useIntl } from "react-intl";
import useAsyncSelectFormInput from "../../../../hooks/useAsyncSelectFormInput";
import { PatientDetailsFormInputs } from "../../../../models/users.interface";
import usersService from "../../../../services/users.service";
import SelectFormInput from "../../../Shared/SelectInput/SelectFormInput";

type PrescribingPhysicianSelectFormInputProps = {
  control: Control<PatientDetailsFormInputs, object>;
  required?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
};

const PrescribingPhysicianSelectFormInput = ({
  isInvalid,
  disabled,
  control,
  required = false,
}: PrescribingPhysicianSelectFormInputProps) => {
  const intl = useIntl();

  const physicianRequiredPlaceholder = intl.messages[
    "MANAGEMENT.ADD_PATIENT.PHYSICIAN_REQUIRED"
  ] as string;

  const loadItems = useCallback(async () => {
    const prescribingPhysicians = await usersService.getPrescribingPhysicians();
    return prescribingPhysicians ?? null;
  }, []);

  const { selectItems, selectPlaceholder } = useAsyncSelectFormInput(
    loadItems,
    physicianRequiredPlaceholder
  );

  return (
    <SelectFormInput<PatientDetailsFormInputs>
      name={"prescribingPhysician"}
      control={control}
      rules={{
        required: required,
      }}
      input={{
        items: selectItems,
        placeholder: selectPlaceholder,
        isInvalid: isInvalid,
        disabled: disabled,
      }}
    />
  );
};

export default PrescribingPhysicianSelectFormInput;
